import { useParams } from "infrastructure/router";
import Resource from "ui/layouts/Resource";
import type { PlatformSetupRouteParams } from "./types";
import PlatformSetupStepper from "./PlatformSetupStepper";
import withIndexRedirect from "./withIndexRedirect";

const PlatformSetup = () => {
    const { platform } = useParams<PlatformSetupRouteParams>();

    return (
        <Resource
            breadcrumbsProps={{
                heading: `Connect ${platform}`,
                links: [
                    {
                        name: 'Follow the steps below to activate your platform.'
                    }
                ]
            }}
        >
            <PlatformSetupStepper />
        </Resource>
    );
};

export default withIndexRedirect(PlatformSetup);
